import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmContractPaymentNode {
  name?: string
  amount?: number
  dueDate?: string
}

export interface FirmContractVO {
  id?: number
  caseId: number
  customerId?: number
  customerName?: string
  contractNo?: string
  title: string
  status?: string
  amount?: number
  signDate?: string
  matterSummary?: string
  paymentNodes?: FirmContractPaymentNode[]
  templateId?: number
  contentSnapshot?: string
  signedFileUrl?: string
  marketplaceSignId?: number
  remark?: string
  createTime?: string
  nextStatuses?: string[]
}

export interface FirmContractPageReqVO extends PageParam {
  caseId?: number
  customerId?: number
  status?: string
  contractNo?: string
  title?: string
}

export const FirmContractApi = {
  page: async (params: FirmContractPageReqVO): Promise<PageResult<FirmContractVO>> =>
    request.get({ url: '/lawyer/firm/contract/page', params }),
  get: async (id: number): Promise<FirmContractVO> =>
    request.get({ url: '/lawyer/firm/contract/get', params: { id } }),
  listByCase: async (caseId: number): Promise<FirmContractVO[]> =>
    request.get({ url: '/lawyer/firm/contract/list', params: { caseId } }),
  create: async (data: FirmContractVO): Promise<number> =>
    request.post({ url: '/lawyer/firm/contract/create', data }),
  update: async (data: FirmContractVO): Promise<boolean> =>
    request.put({ url: '/lawyer/firm/contract/update', data }),
  transition: async (data: { id: number; toStatus: string }): Promise<boolean> =>
    request.put({ url: '/lawyer/firm/contract/transition', data }),
  uploadSigned: async (data: {
    id: number
    signedFileUrl: string
    signDate?: string
    markSigned?: boolean
  }): Promise<boolean> => request.put({ url: '/lawyer/firm/contract/upload-signed', data })
}

export const CONTRACT_STATUS_OPTIONS = [
  { label: '草稿', value: 'DRAFT' },
  { label: '待签署', value: 'PENDING_SIGN' },
  { label: '已签署', value: 'SIGNED' },
  { label: '已终止', value: 'TERMINATED' },
  { label: '作废', value: 'VOID' }
]

export function contractStatusLabel(code?: string) {
  return CONTRACT_STATUS_OPTIONS.find((o) => o.value === code)?.label || code || '-'
}
